import { Chip } from '@mui/material';
import { PersonOutline as PersonIcon } from '@mui/icons-material';
type User = {
    login: string;
};

type Props = {
    user: User;
};

/**
 * Chip user
 */
export function SttChipUser({ user }: Props): React.ReactElement {
    return (
        <>
            {user && (
                <Chip icon={<PersonIcon />} size="small" label={user.login} />
            )}
        </>
    );
}
